import React, {useContext, useState} from "react";
import {BoShowContext} from "../context/bo-show-context.jsx";
import InputTextarea from "../../../../../components/input/input-textarea.jsx";
import Button from "../../../../../components/button/button.jsx";
import projectUtils from "../../../../../utils/project-utils.js";
import {useLoaderData} from "react-router";
import bosService from "../../../../../services/web/bos-service.js";
import {toast} from "react-toastify";

const BoShowAddRectification = () => {
    const {id, dataFetch, setIsLoading, refetch} = useContext(BoShowContext);
    const loaderData = useLoaderData();

    const [rectification, setRectification] = useState("")

    const rectify = dataFetch?.bogcm?.actions?.rectify;

    if (!rectify) return null;

    const onClick = () => {
        if (!rectification){
            projectUtils.swalErrorMessage("", "O campo \"Retificação\" é obrigatório.");
            return;
        }

        projectUtils.swalMessage(
            "warning",
            "Retificar "+ loaderData?.bo_name,
            `Deseja retificar o ${loaderData?.bo_name}?`,
            "Sim",
            true,
            "Não",
            ({isConfirmed}) => {
                if (isConfirmed) {
                    const body = {
                        id: id,
                        rectification,
                    };

                    setIsLoading(true)
                    bosService.rectify(new URLSearchParams(body))
                        .then(() => {
                            refetch();
                            toast.success("Retificado com sucesso");
                            setRectification("");
                        })
                        .catch(error => {
                            console.error(error);
                            let message = `Erro ao retificar ${loaderData?.bo_name}`;
                            if (error.response.status !== 500) {
                                message = error.response.data.message;
                            }

                            projectUtils.swalErrorMessage('', message, 'Ok');
                        })
                        .finally(() => setIsLoading(false))
                }
            }
        )
    }

    return (
        <div className={"print:hidden"}>
            <hr className={"opacity-25 text-[#676a6c]"}/>
            <article className={"space-y-4"}>
                <h2 className={"text-center"}>Retificar</h2>

                <InputTextarea
                    id={"rectification"}
                    value={rectification}
                    onChange={({target}) => setRectification(target.value)}
                    label={"Retificação *"}
                    textAreaClass={"h-40"}
                />

                <Button
                    className={"justify-self-end"}
                    onClick={onClick}
                    actionFeedbackType="save"
                    deferActionFeedback
                    loadingText="Retificando..."
                    successText="Retificado com sucesso"
                >
                    Retificar
                </Button>
            </article>
        </div>
    );
};

export default BoShowAddRectification;